<template>
    <div class="login">
        <div class="box">
            <p class="tit">登录</p>
            <div class="bom">
                <p class="txt" v-if="isfalse">{{txt}}</p>
                <div class="ti">
                    <span>账号</span>
                    <input type="text" v-model="name" placeholder="请输入账号">
                </div>
                <div class="ti">
                    <span>密码</span>
                    <input type="password" v-model="pass" placeholder="请输入账号">
                </div>
                <button @click="login">登录</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            isfalse: false,
            name:'dimabi2020',
            pass:'DMbi@479961',
            txt: '账号或密码错误'
        }
    },
    methods: {
        login() {
            console.log(55)
            if(!this.name || !this.pass) {
                this.isfalse =true
                this.txt ='请输入账号密码'
                return
            }
            if(this.name === 'dimabi2020' && this.pass === 'DMbi@479961') {
                sessionStorage.setItem('isok',1)
                this.$router.push('/home')
            }else{
                this.isfalse =true
                this.txt ='账号或密码错误'
            }
        }
    }
}
</script>
<style>
    .login {
        width: 1920px;
        height: 1080px;
        font-size: 20px;
    }
    .box {
        border: 1px solid #ccc;
        width: 440px;
        height: 340px;
        position: relative;
        left: 50%;
        margin-left: -220px;
        top: 35%;
        margin-top: -200px;
    }
    .tit {
        font-size: 20px;
        line-height: 40px;
        border-bottom: 1px solid #cccccc;
        margin-top: 0;
    }
    .txt {
        color: #E6A23C;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -10px;
    }
    .bom {
        position: relative;
        padding-top: 60px;
    }
    .ti {
        margin-bottom: 30px;
    }
    .ti span {
        margin-right: 30px;
    }
    .ti input {
        width: 260px;
        height: 40px;
        outline: none;
        padding-left: 10px;
        border: 1px solid #303133;
        border-radius: 4px;
        font-size: 18px;
    }
    button {
        width: 200px;
        height: 40px;
        border: 0;
        outline: none;
        text-align: center;
        line-height: 40px;
        background: #409EFF;
        color: #ffffff;
        border-radius: 5px;
        margin-left: 30px;
    }
</style>